'use client';

import { MatchCardV2 } from '@pickleballinc/react-ui';
import { useRouter } from 'next/navigation';

import { MatchExtended, MatchInfo } from '@/modules/ticker/types';
import { formatMatchInfo } from '@/utils/helpers/formatMatchInfo';

export interface RenderMatchesProps {
  initialMatches: MatchInfo[];
  title: string;
}

export const RenderMatches = ({ initialMatches, title }: RenderMatchesProps) => {
  const router = useRouter();
  if (initialMatches.length === 0) return null;

  const formattedResults: MatchExtended[] = formatMatchInfo({
    matchInfos: initialMatches,
    imagesWidth: 22,
    imagesHeight: 22,
  });

  const onMatchCardClick = (matchUuid?: string) => {
    router.push(`/results/match/${matchUuid}`);
  };

  return (
    <div className='flex w-full flex-col gap-4 rounded-lg bg-white pb-1'>
      <h3 className='w-full text-left text-sm font-bold leading-5 tracking-normal'>{title}</h3>
      <div
        className={`grid gap-2 ${formattedResults.length > 1 ? 'grid-cols-1 sm:grid-cols-2' : 'grid-cols-1'}`}
      >
        {formattedResults.map((result) => (
          <div
            key={result.id}
            className='cursor-pointer hover:opacity-80'
            onClick={() => onMatchCardClick(result.id)}
          >
            <MatchCardV2 match={result} compact shortenName forTicker={false} />
          </div>
        ))}
      </div>
    </div>
  );
};
